import _ from "underscore";
import fbq from "web/script/embedded/facebook-tag-manager";
import facebookEvents from "../facebook-events";

/**
 * This handles all events from our analytics pipeline for facebook_events (anything sent
 * with tagEvent for FACEBOOK). The send method will collect any relevant events that have
 * been passed in, and push the track to the FB event queue, OR, create a static image pixel to
 * track.
 *
 * The reason for the static pixel is because we cannot wait until the tag has successfully been
 * sent to FB using their standard method, so to ensure it is sent in some circumstances (ie.
 * the affiliate lead page), we create an image that we know is successful or not.
 */
export default {
    accountId: "684955101576177",

    init: function() {
        fbq("init", this.accountId);
    },

    send: function(data) {
        // this will contain any promises we generate
        var promises = [];

        _.each(data, (event) => {
            // only deal with facebook_events
            if (event.type !== "facebook_event") {
                return;
            }

            var track = event.data;

            // if we've specified to wait, we need to create an image and push a new promise
            if (event.wait) {
                promises.push(
                    new Promise((resolve) => {
                        // create the image
                        var img = document.createElement("img");
                        img.onerror = img.onload = resolve;

                        // any custom data needs to be put into a custom data format
                        // &cd[key]=value&cd[key2]=value2...
                        let customDataString = this.getCustomDataString(track.customData);

                        // set the image src
                        img.src = `https://www.facebook.com/tr?id=${this.accountId}&ev=${
                            track.eventName
                        }${customDataString}`;

                        // you've got three seconds
                        window.setTimeout(resolve, 3000);
                    })
                );
            } else {
                let trackType = facebookEvents.STANDARD_EVENTS.includes(track.eventName)
                    ? "track"
                    : "trackCustom";

                // do it the regular way, less intensive
                fbq(trackType, track.eventName, track.customData || {});
            }
        });

        return promises.length > 0 ? Promise.all(promises) : Promise.resolve();
    },

    getCustomDataString(customData) {
        let customDataString = "";

        if (!customData) {
            return customDataString;
        }

        for (let customKey in customData) {
            if (!customData.hasOwnProperty(customKey)) {
                continue;
            }

            let customValue = customData[customKey];
            customDataString = `${customDataString}&cd[${customKey}]=${customValue}`;
        }

        return customDataString;
    },
};
